import pick from "lodash/pick";

// We would like to remove this hoc and simply use the params or a hook.

// Accept array or string
// withRouteParams(["classroomId", "schoolId"])
// withRouteParams("classroomId")
const withRouteParams = (routeParamNames: string | string[]) => {
  if (!Array.isArray(routeParamNames)) routeParamNames = [routeParamNames];

  // eslint-disable-next-line react/display-name
  return (Component: React.ComponentClass) => (props: Record<string, unknown>) => {
    const pickedParams = pick(props.params, routeParamNames);
    return <Component {...pickedParams} {...props} />;
  };
};

export default withRouteParams;
